function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  stroke: "#262C37",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeOpacity: 0.25,
  strokeWidth: 2,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  strokeDasharray: "4,4",
  d: "M444.2 77h-4.272V58.79c0-1.132-.683-2.155-1.742-2.617-10.17-4.435-17.246-14.418-17.186-26.01.08-15.347 12.866-27.947 28.586-28.16C465.792 1.783 479 14.54 479 30.31c0 11.527-7.056 21.443-17.182 25.86-1.06.463-1.745 1.486-1.745 2.62V77H455.8l-2.614 3.634c-.22.229-.59.366-.987.366H447.8c-.397 0-.767-.137-.988-.366L444.2 77z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M444 33l3.223-3.711L450.447 33l3.473-4 3.08 3.546"
}));

function SvgSeparate1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 82
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5MDAiIGhlaWdodD0iODIiIHZpZXdCb3g9IjAgMCA5MDAgODIiPgogICAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBzdHJva2U9IiMyNjJDMzciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLW9wYWNpdHk9Ii4yNSIgc3Ryb2tlLXdpZHRoPSIyIj4KICAgICAgICAgICAgPHBhdGggc3Ryb2tlLWRhc2hhcnJheT0iNCw0IiBkPSJNNDQ0LjIgNzdoLTQuMjcyVjU4Ljc5YzAtMS4xMzItLjY4My0yLjE1NS0xLjc0Mi0yLjYxNy0xMC4xNy00LjQzNS0xNy4yNDYtMTQuNDE4LTE3LjE4Ni0yNi4wMS4wOC0xNS4zNDcgMTIuODY2LTI3Ljk0NyAyOC41ODYtMjguMTZDNDY1Ljc5MiAxLjc4MyA0NzkgMTQuNTQgNDc5IDMwLjMxYzAgMTEuNTI3LTcuMDU2IDIxLjQ0My0xNy4xODIgMjUuODYtMS4wNi40NjMtMS43NDUgMS40ODYtMS43NDUgMi42MlY3N0g0NTUuOGwtMi42MTQgMy42MzRjLS4yMi4yMjktLjU5LjM2Ni0uOTg3LjM2Nkg0NDcuOGMtLjM5NyAwLS43NjctLjEzNy0uOTg4LS4zNjZMNDQ0LjIgNzd6Ii8+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik00NDQgMzNsMy4yMjMtMy43MTFMNDUwLjQ0NyAzM2wzLjQ3My00IDMuMDggMy41NDYiLz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgSeparate1 as ReactComponent };